import React from 'react';
import { Badge, HStack } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { useTranslation } from 'react-i18next';

import { Comment } from 'types';

export interface CommentTypeTagsProps {
  comment: Comment;
}
const Tag: React.FC = ({ children }) => (
  <Badge
    display='flex'
    justifyContent='center'
    fontSize='sm'
    w='96px'
    h='24px'
    color='black'
    backgroundColor={COLOURS.blue[150]}
  >
    {children}
  </Badge>
);
export const CommentTypeTags: React.FC<CommentTypeTagsProps> = ({ comment }) => {
  const { isPetition, type } = comment;

  const { t } = useTranslation('comment_type');

  return (
    <HStack>
      {isPetition ? <Tag>{t('petition', 'Petition')}</Tag> : null}
      <Tag>{type}</Tag>
    </HStack>
  );
};
